<div class="flex flex-col items-center px-4">
  <div class="w-full max-w-2xl mt-6 lg:w-screen">
    <h3 class="mb-6 text-xl font-bold">Status płatności</h3>
    <div class="flex justify-center text-red-600">
      <img class="error-icon" src="assets/img/cancelled.svg" alt="Płatność anulowana" />
    </div>
    <div class="mt-6 mb-4 text-2xl text-center text-gray-900">
      Link do płatności jest nieaktywny
    </div>

    <div class="mb-8 text-sm text-center text-gray-700">
      Twój dostawca usług anulował tę płatność zanim udało Ci się ją opłacić.
      <br class="hidden md:flex" />
      Sprawdź, czy w Twojej skrzynce email lub panelu klienta nie pojawił się link do nowej płatności.
      <br /><br />
      Spróbuj ponownie, a jeśli problem się powtarza,
      <a
        (click)="openChat()"
        class="text-gray-700 underline transition-colors duration-150 cursor-pointer hover:text-gray-500"
        >napisz do nas</a
      >.
    </div>

    <app-value-proposition [highlight]="true"></app-value-proposition>
  </div>
</div>
